import { Alert, Snackbar } from "@mui/material";
import React from "react";

const SnackbarAlert = ({
  isOpen,
  onClose,
  duration = 3000,
  alertColor="success",
  alertVariant="standard",
  alertSeverity="success",
  massage,
  vertical = "top",
  horizontal = "right",
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={isOpen}
      autoHideDuration={duration}
      onClose={onClose}
    >
      <Alert variant={alertVariant} severity={alertSeverity} color={alertColor}>
        {massage}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
